import { createFileRoute } from '@tanstack/react-router'
import { listSearchSchema } from '@/lib/list-search-schema'
import { lazy, Suspense } from 'react'

const CustomSlotRequests = lazy(() => import('@/pages/CustomSlotRequests'))

export const Route = createFileRoute('/_authenticated/scheduling/custom-slot-requests')({
  validateSearch: listSearchSchema,
  component: () => (
    <Suspense fallback={<div className="animate-pulse space-y-4"><div className="h-8 w-48 bg-muted rounded" /><div className="h-64 bg-muted rounded-xl" /></div>}>
      <CustomSlotRequests />
    </Suspense>
  ),
})
